<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v">
<h1 class="title1">The Lost Girl</h1>
<p class="subtitle">A Mickey Keller Thriller</p>
<p class="author">Alan Jacobson</p>
<div class="img_container">
<img alt="images" src="image/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?e7f02e64